import { validateTidalLicense } from "../../base/index.js";
import { trimLeft } from "./trimLeft.js";
import { trimRight } from "./trimRight.js";
import { WHITE_SPACES } from "./utils/constants.js";
function trim(source, chars = WHITE_SPACES) {
  return trimLeft(trimRight(source, chars), chars);
}
validateTidalLicense();
export {
  trim
};
//# sourceMappingURL=trim.js.map
